import SvgIcon from "@mui/material/SvgIcon";
const VoicemailBlue = (props) => {
  return (
    <SvgIcon {...props}>
      <g
        id="Data_Blue"
        data-name="Data Blue"
        transform="translate(-2.25 -2.25)"
      >
        <path
          id="Path_5"
          data-name="Path 5"
          class="cls-1"
          d="M9.4,8.75H3.6A1.352,1.352,0,0,1,2.25,7.4V3.6A1.352,1.352,0,0,1,3.6,2.25H9.4A1.352,1.352,0,0,1,10.75,3.6V7.4A1.352,1.352,0,0,1,9.4,8.75ZM3.75,7.25h5.5V3.75H3.75Z"
        />
        <path
          id="Path_6"
          data-name="Path 6"
          class="cls-1"
          d="M20.4,21.75H14.6a1.352,1.352,0,0,1-1.35-1.35V16.6a1.352,1.352,0,0,1,1.35-1.35h5.8a1.352,1.352,0,0,1,1.35,1.35v3.8A1.352,1.352,0,0,1,20.4,21.75Zm-5.65-1.5h5.5v-3.5h-5.5Z"
        />
        <path
          id="Path_7"
          data-name="Path 7"
          class="cls-1"
          d="M20.4,13.75H14.6a1.352,1.352,0,0,1-1.35-1.35V3.6A1.352,1.352,0,0,1,14.6,2.25h5.8A1.352,1.352,0,0,1,21.75,3.6v8.8A1.352,1.352,0,0,1,20.4,13.75Zm-5.65-1.5h5.5V3.75h-5.5Z"
        />
        <path
          id="Path_8"
          data-name="Path 8"
          class="cls-1"
          d="M9.4,21.75H3.6A1.352,1.352,0,0,1,2.25,20.4V11.6A1.352,1.352,0,0,1,3.6,10.25H9.4a1.352,1.352,0,0,1,1.35,1.35v8.8A1.352,1.352,0,0,1,9.4,21.75Zm-5.65-1.5h5.5v-8.5H3.75Z"
        />
      </g>
    </SvgIcon>
  );
};
export default VoicemailBlue;
